import { useFormikContext } from "formik";
import { FloatingLabel, Form } from "react-bootstrap";
import { StripeConfiguration } from "../../models";

export const StripeConfigurationForm = () => {
  interface FormValues {
    configuration: StripeConfiguration;
  }
  const { values, handleChange, errors, touched } = useFormikContext<FormValues>();

  return (
    <div className="row">
      <div className="col col-24 mb-3">
        <FloatingLabel label="Account">
          <Form.Control
            name="configuration.Account"
            value={values.configuration.account ?? ""}
            isInvalid={!!errors.configuration?.account && !!touched.configuration?.account}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">
            {errors.configuration?.account}
          </Form.Control.Feedback>
        </FloatingLabel>
      </div>
      <div className="col col-24 mb-3">
        <FloatingLabel label="API Key">
          <Form.Control
            name="configuration.APIKey"
            value={values.configuration.apiKey ?? ""}
            isInvalid={!!errors.configuration?.apiKey && !!touched.configuration?.apiKey}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">
            {errors.configuration?.apiKey}
          </Form.Control.Feedback>
        </FloatingLabel>
      </div>
      <div className="col col-24 mb-3">
        <FloatingLabel label="Public Key">
          <Form.Control
            name="configuration.PublicKey"
            value={values.configuration.publicKey ?? ""}
            isInvalid={!!errors.configuration?.publicKey && !!touched.configuration?.publicKey}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">
            {errors.configuration?.publicKey}
          </Form.Control.Feedback>
        </FloatingLabel>
      </div>
      <div className="col col-24">
        <FloatingLabel label="Currency">
          <Form.Select
            name="configuration.Currency"
            value={values.configuration.currency ?? ""}
            isInvalid={!!errors.configuration?.currency && !!touched.configuration?.currency}
            onChange={handleChange}
          >
            <option value="">Select a currency</option>
            <option value="cad">CAD</option>
            <option value ="usd">USD</option>
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errors.configuration?.currency}
          </Form.Control.Feedback>
        </FloatingLabel>
      </div>
    </div>
  )
}

export default StripeConfigurationForm;
